<template>
  <div class>
    <STable ref="tableref" :url="url" :columns="columns" :selection="false" :query="[]" :handles="handles" :toolbar="toolbar" />
    <el-dialog v-dialogDrag title="用户列表" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="closeDialog" width="80%" top="10vh" center>
      <STable
        ref="userListRef"
        :url="userUrl"
        :columns="userColumns"
        :handles="{}"
        :query="userQuery"
        :toolbar="userToolbar"
        label-width="80px"
      />
    </el-dialog>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'UserLevel',
  data() {
    return {
      dialogVisible: false, // 用户列表弹窗
      id: '',
      url: '/business/userLevel/page',
      columns: [
        {
          label: '等级名称',
          prop: 'levelName'
        },
        {
          label: '经验值要求',
          prop: 'empiricalValue'
        },
        {
          label: '绑定权益',
          prop: 'bindRaiName'
        },
        {
          label: '当前等级人数',
          prop: 'currentPeople'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'equityManagement.userRating.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'addUserLevel'
            })
          }
        }
      ],
      handles: {
        width: 100,
        btns: [
          {
            label: '用户列表',
            permission: 'equityManagement.userRating.list',
            type: 'primary',
            before: (index, record) => {
              this.dialogVisible = true
              this.id = record.id
              this.userUrl = this.userUrl + '?levelId=' + record.id
            }
          }
        ]
      },
      userUrl: '/business/userLevel/userList',
      userQuery: [
        {
          label: '用户账号',
          prop: 'userId',
          placeholder: '请输入用户账号'
        },
        {
          label: '用户姓名',
          prop: 'userName',
          placeholder: '请输入用户姓名'
        },
        {
          label: '用户类型',
          prop: 'unit',
          placeholder: '请选择用户类型',
          type: 'select',
          data: [{
            label: '企业用户',
            value: 1
          }, {
            label: '非企业用户',
            value: 0
          }]
        },
        {
          label: '手机号',
          prop: 'phone',
          placeholder: '请输入手机号'
        },
        {
          label: '用户状态',
          prop: 'frozen',
          placeholder: '请选择用户状态',
          type: 'select',
          data: [{
            label: '正常',
            value: 0
          }, {
            label: '冻结',
            value: 1
          }]
        }
      ],
      userColumns: [
        {
          label: '所属公司',
          prop: 'companyName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '用户类型',
          prop: 'unit',
          template: function(index, reocrd) {
            return reocrd.unit === 'true'
              ? '企业用户'
              : '非企业用户'
          }
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '经验值',
          prop: 'empiricalValue'
        },
        {
          label: '升级时间',
          prop: 'updateDate'
        },
        {
          label: '状态',
          prop: 'frozen',
          template: function(index, reocrd) {
            return reocrd.frozen === 'true'
              ? "<span class='tag danger'>冻结</span>"
              : "<span class='tag success'>正常</span>"
          }
        }
      ],
      userToolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          permission: 'equityManagement.userRating.list.export',
          type: 'primary',
          before: (index, record) => {
            const url = HOST + '/business/userLevel/export'
            const data = this.$refs.userListRef.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'POST',
              data: {
                token: window.localStorage.getItem('token'),
                levelId: this.id,
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户列表失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  beforeMount() {},
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.id = ''
      this.userUrl = '/business/userLevel/userList'
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发

}
</script>

<style lang="less" src="" scoped>
  /deep/.el-dialog--center{
    padding-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/equityManagement/userLevel.vue